export const payments = (state) => {
  return state.payments ? state.payments : []
}
